<template>
  <div class="page back-cover">
    <canvas id="canvas" width="29120" height="624"></canvas>

    <img id="preview" src="" alt="" />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'BackCover',
  data: function ()  {
    return {
      // title: '美好生活 拼出来'
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    console.log('backCover mounted')

    const canvas = document.querySelector('#canvas')
    const ctx = canvas.getContext('2d')

    const imgs = []
    let loadedimg = 0

    for (let i = 7; i <= 62; i++) {
      const img = document.createElement('img')
      
      img.addEventListener('load', () => {
        imgs[i] = img

        loadedimg ++
        console.log('load', loadedimg + 7)
        if (loadedimg === 56) {
          // 
          // let imgIndex = 0
          
          for (let j = 7; j <= 62; j++) {
            // 520 * 624
            ctx.drawImage(imgs[j], 0, 0, 520, 624, j * 520, 0, 520, 624)
          }

          document.querySelector('#preview').src = canvas.toDataURL('image/png', 0.9)
        }
      })

      if (i < 10) {
        img.src = this.$config.publicPath + 'img/sublime/1_0000' + i + '.png'
      } else {
        img.src = this.$config.publicPath + 'img/sublime/1_000' + i + '.png'
      }
    }
  },
  methods: {
    replay () {
      this.$emit('replay')
    }
  }
}
</script>

<style lang="scss" scoped>
.back-cover {
  // background-color: #67C23A;
  background-color: #ffffff;
  overflow-y: auto;
  font-size: 0;
}

canvas, img {
  width: 100%;
}
</style>
